import React from 'react'

function Usernameconfirm() {
  return (
    <div className="form-container">
      <div className="form-content-left">
        <img className="form-img" src="https://i.imgur.com/hPOPqz3.jpg"></img>
      </div>
      <div className="form-content-right">
        <h1 className="title">Username sent, check your email!</h1>
      </div>
    </div>
  );
}

export default Usernameconfirm